<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section">D<span class="smallcaps">AY </span>O<span class="smallcaps">NE </span></h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// the-dark-remains_00003.vue?335a0f40